export const SET_DEPARTMENT = 'SET_DEPARTMENT';
export const SET_DEPARTMENTS = 'SET_DEPARTMENTS';
export const SET_DEPARTMENTS_QUERY_PARAMS = 'SET_DEPARTMENTS_QUERY_PARAMS';
export const SET_DEPARTMENTS_SET_IS_FETCHING = 'SET_DEPARTMENTS_SET_IS_FETCHING';

export const SET_DICTDEPARTMENT = 'SET_DICTDEPARTMENT';
export const SET_DICTDEPARTMENTS = 'SET_DICTDEPARTMENTS';
export const SET_DICTDEPARTMENTS_QUERY_PARAMS = 'SET_DICTDEPARTMENTS_QUERY_PARAMS';
export const SET_DICTDEPARTMENTS_SET_IS_FETCHING = 'SET_DICTDEPARTMENTS_SET_IS_FETCHING';
